import type {AlertPayload, graphSpec} from '../../../components/copilot/types';
import type {Signal} from '../../../components/signals-screen/types';
import {PolarisChatAggregate, PolarisChatOverview, PolarisTurn} from './polaris-domain.models';
import {PolarisAccountKey, PolarisChatId} from './polaris-api.models';
import type {PolarisMigrationErrorCategory} from './polaris-runtime.models';

export const POLARIS_RUNTIME_STRATEGIES = ['polaris_only', 'legacy_only', 'migration'] as const;
export type PolarisRuntimeStrategy = (typeof POLARIS_RUNTIME_STRATEGIES)[number];

export interface PolarisLegacyChatMessage {
  id: string;
  author: 'user' | 'assistant';
  content: string;
  timestamp: number;
  followUpQuestions?: string[];
  error?: string;
  insights?: string;
  creativesURLs?: string[];
  interactionId?: string;
  origin?: string;
  widgetName?: string;
  widgetContext?: unknown;
  graphs?: graphSpec[];
}

export interface PolarisLegacyChat {
  id: PolarisChatId;
  messages: PolarisLegacyChatMessage[];
  title: string;
  lastUpdate: number;
  avoidGreeting?: boolean;
  myBrand?: string;
  myCompetitors?: string[];
  wizard?: unknown;
  alert?: AlertPayload;
  signal?: Signal;
  origin?: string;
  widgetName?: string;
  widgetContext?: unknown;
}

export type PolarisLegacyChatsMap = Record<PolarisChatId, PolarisLegacyChat>;

export interface PolarisMigrationInput {
  accountKey: PolarisAccountKey;
  userId: string;
  legacyChats: PolarisLegacyChatsMap;
}

export interface PolarisMigrationResult {
  uploadedChatIds: PolarisChatId[];
  skippedChatIds: PolarisChatId[];
  failedChatIds: PolarisChatId[];
}

export interface PolarisMigrationTransformResult {
  overviews: PolarisChatOverview[];
  chats: PolarisChatAggregate[];
  turnsByChatId: Record<PolarisChatId, PolarisTurn[]>;
}

export interface PolarisMigrationUploadError {
  attemptCount: number;
  category: PolarisMigrationErrorCategory;
  statusCode?: number;
  retryable: boolean;
  retryExhausted: boolean;
  message: string;
}
